import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({name: 'UserProfiles', namespaced: true})
export default class UserProfiles extends VuexModule {
    public allUserProfiles: any[] = [];
    public currentUserProfile: any = [];
    public profileSearchOption: any = '';
    public previewUserProfileVisibility: boolean = false;

    @Mutation
    public SET_USER_PROFILES_STORE_STATE() {
        this.allUserProfiles              = [];
        this.currentUserProfile           = [];
        this.profileSearchOption          = '';
        this.previewUserProfileVisibility = false;
    }

    get getAllUserProfiles() {
        return this.allUserProfiles;
    }

    get getProfileSearchOption() {
        return this.profileSearchOption;
    }

    get getCurrentUserProfile() {
        return this.currentUserProfile;
    }

    get getPreviewUserProfileVisibility() {
        return this.previewUserProfileVisibility;
    }

    @Action
    public RESET_ACTIVE_INTEGRATION_SORTS(column: string) {
        const sorts = document.querySelectorAll('.hococo-admin-integration-header i');
        sorts.forEach( (sort) => {
            if (sort.getAttribute('data-sort-key') !== column) {
                if (!sort.classList.contains('fa-angle-down')) {
                    sort.classList.add('fa-angle-down');
                }
                if (sort.classList.contains('fa-angle-up')) {
                    sort.classList.remove('fa-angle-up');
                }
            }
        });
    }

    @Mutation
    public SET_PREVIEW_USER_PROFILE_VISIBILITY(visibility: boolean) {
        this.previewUserProfileVisibility = visibility;
    }

    @Mutation
    public SET_ALL_USER_PROFILES(data: any) {
        this.allUserProfiles = data;
    }

    @Mutation
    public SET_CURRENT_USER_PROFILE(data: any) {
        this.currentUserProfile = data;
    }

    @Mutation
    public SET_USER_PROFILE_SEARCH_OPTION(search: any) {
        this.profileSearchOption = search;
    }
}
